import { useParams, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import SEO from "@/components/feature/SEO";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { categoryData } from "@/mocks/siteData";

const categorySlugMap: Record<string, keyof typeof categoryData> = {
  "wanghong-heiliao": "wanghong",
  "mingxing-bagua": "mingxing",
  "shehui-qiwen": "shehui",
};

const categoryMeta: Record<string, { title: string; description: string; keywords: string }> = {
  wanghong: {
    title: "网红黑料 - 911爆料网 | 网红黑料实时追踪",
    description: "911爆料网网红黑料频道，追踪全网网红不为人知的另一面。独家爆料网红圈内幕，吃瓜第一线。涵盖短视频、直播、电商等各领域网红真实黑料，每日更新。",
    keywords: "网红黑料,网红爆料,网红八卦,911爆料网,直播黑料,网红翻车",
  },
  mingxing: {
    title: "明星八卦 - 911爆料网 | 娱乐圈最新明星八卦资讯",
    description: "911爆料网明星八卦频道，娱乐圈最新最热的明星八卦资讯。影视歌三栖明星动态一手掌握，从恋情曝光到事业风波，不错过任何一个瓜。",
    keywords: "明星八卦,娱乐圈爆料,明星丑闻,911爆料网,明星出轨,综艺爆料",
  },
  shehui: {
    title: "社会奇闻 - 911爆料网 | 社会热点奇闻异事",
    description: "911爆料网社会奇闻频道，大千世界无奇不有。每日精选社会热点奇闻异事，聚焦民生百态，深度挖掘不为人知的社会现象与离奇事件。",
    keywords: "社会奇闻,奇闻异事,社会热点,911爆料网,离奇事件,社会新闻",
  },
};

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeTab, setActiveTab] = useState<string>("all");
  const dataKey = slug ? categorySlugMap[slug] : undefined;
  const data = dataKey ? categoryData[dataKey] : null;
  const meta = dataKey ? categoryMeta[dataKey] : null;

  const tabs = [
    { key: "all", label: "全部" },
    { key: "latest", label: "最新爆料" },
    { key: "hot", label: "热门追踪" },
    { key: "exclusive", label: "独家深度" },
  ];

  const filteredArticles = (() => {
    if (!data) return [];
    const all = [...data.articles];
    switch (activeTab) {
      case "latest":
        return all.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
      case "hot":
        return all.sort((a, b) => b.views - a.views);
      case "exclusive":
        return all.slice(0, 2);
      default:
        return all;
    }
  })();

  const featuredArticle = filteredArticles[0];
  const sideArticles = filteredArticles.slice(1);

  useEffect(() => {
    setActiveTab("all");
  }, [slug]);

  const formatViews = (n: number) => {
    if (n >= 10000) return `${(n / 10000).toFixed(1)}万`;
    return n.toString();
  };

  if (!data || !meta) {
    return (
      <>
        <Navbar />
        <div className="min-h-screen flex items-center justify-center pt-16">
          <div className="text-center">
            <h2 className="text-2xl font-heading text-foreground-100 mb-4">分类不存在</h2>
            <Link to="/" className="text-primary-400 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap">
              返回首页
            </Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  const categoryArticleSchema = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": meta.title,
    "description": meta.description,
    "url": `https://911baoliao.com/category/${slug}`,
    "inLanguage": "zh-CN",
    "mainEntity": {
      "@type": "ItemList",
      "itemListElement": filteredArticles.map((article, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "url": `https://911baoliao.com/article/${article.id}`,
        "name": article.title,
      })),
    },
  };

  return (
    <>
      <SEO
        title={meta.title}
        description={meta.description}
        keywords={meta.keywords}
        canonicalUrl={`https://911baoliao.com/category/${slug}`}
        ogTitle={meta.title}
        ogDescription={meta.description}
        ogType="website"
        schema={categoryArticleSchema}
      />
      <Navbar />
      <main>
        <section className="px-4 md:px-8 pt-16 pb-8">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb
              items={[
                { label: "首页", path: "/" },
                { label: data.title, path: `/category/${slug}` },
              ]}
            />

            <div className="flex gap-2 mt-6 mb-2 flex-wrap">
              {tabs.map((tab) => (
                <button
                  key={tab.key}
                  onClick={() => setActiveTab(tab.key)}
                  className={`px-4 py-2 text-sm rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap ${
                    activeTab === tab.key
                      ? "bg-primary-500 text-foreground-50 dark:text-foreground-950 font-medium"
                      : "bg-background-200/50 text-foreground-400 hover:text-foreground-200 hover:bg-background-200"
                  }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mt-4">
              <div className="lg:col-span-7">
                {featuredArticle && (
                  <>
                    <div className="relative rounded-2xl overflow-hidden aspect-[16/10]">
                      <img
                        src={featuredArticle.image || ""}
                        alt={data.title}
                        className="w-full h-full object-cover"
                        title={`911爆料 - ${data.title}`}
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-background-100/80 to-transparent"></div>
                      <div className="absolute top-4 left-4 flex gap-2">
                        <span className="px-2.5 py-1 rounded-full bg-background-100/70 backdrop-blur-sm text-foreground-300 text-xs font-medium whitespace-nowrap">
                          {data.title}
                        </span>
                        <span className="px-2.5 py-1 rounded-full bg-background-100/70 backdrop-blur-sm text-foreground-400 text-xs whitespace-nowrap">
                          独家
                        </span>
                        <span className="px-2.5 py-1 rounded-full bg-background-100/70 backdrop-blur-sm text-foreground-400 text-xs whitespace-nowrap">
                          热门
                        </span>
                      </div>
                    </div>

                    <div className="mt-6">
                      <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-foreground-50 mb-4">
                        {data.title}
                      </h1>
                      <div className="flex items-center gap-3 flex-wrap mb-2">
                        <span className="px-3 py-1 rounded-full border border-accent-500/40 text-accent-400 text-xs font-medium whitespace-nowrap">
                          实时更新
                        </span>
                        <span className="text-xs text-foreground-500">{filteredArticles.length}条爆料</span>
                      </div>
                      <p className="text-sm text-foreground-500 leading-relaxed">
                        {data.description}
                      </p>
                    </div>

                    <div className="mt-8 bg-background-100 rounded-2xl p-5 md:p-6 border border-background-300/30">
                      <div className="flex items-center gap-2 text-sm text-foreground-400 mb-2">
                        <i className="ri-fire-fill text-primary-400 w-4 h-4 flex items-center justify-center"></i>
                        <span className="font-medium">焦点爆料</span>
                      </div>
                      <Link
                        to={`/article/${featuredArticle.id}`}
                        className="block group cursor-pointer"
                      >
                        <h3 className="text-lg md:text-xl text-foreground-100 font-medium leading-snug group-hover:text-primary-400 transition-colors">
                          {featuredArticle.title}
                        </h3>
                      </Link>
                      <p className="text-sm text-foreground-500 leading-relaxed mt-2">
                        {featuredArticle.excerpt}
                      </p>
                      <div className="mt-4 flex items-center gap-4">
                        <span className="text-xs text-foreground-600">{featuredArticle.date}</span>
                        <span className="text-xs text-foreground-600 flex items-center gap-1">
                          <i className="ri-eye-line w-3.5 h-3.5 flex items-center justify-center"></i>
                          {formatViews(featuredArticle.views)}
                        </span>
                      </div>
                      <div className="mt-4 flex items-center gap-2">
                        <Link
                          to={`/article/${featuredArticle.id}`}
                          className="px-5 py-2 bg-primary-500 hover:bg-primary-600 text-foreground-50 text-sm font-medium rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap dark:text-foreground-950 inline-flex items-center gap-1.5"
                        >
                          查看详情
                          <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                        </Link>
                      </div>
                    </div>
                  </>
                )}
              </div>

              <div className="lg:col-span-5">
                <div className="space-y-4">
                  {sideArticles.map((article) => (
                    <Link
                      key={article.id}
                      to={`/article/${article.id}`}
                      className="flex gap-4 group cursor-pointer bg-background-100/50 rounded-xl p-3 border border-background-300/20 hover:border-background-300/50 transition-colors"
                    >
                      <div className="w-20 h-20 md:w-24 md:h-24 flex-shrink-0 rounded-lg overflow-hidden">
                        <img
                          src={article.image}
                          alt={article.title}
                          className="w-full h-full object-cover"
                          title={`911爆料 - ${article.title}`}
                        />
                      </div>
                      <div className="flex-1 min-w-0">
                        <h4 className="text-sm text-foreground-200 font-medium leading-snug line-clamp-2 group-hover:text-primary-400 transition-colors">
                          {article.title}
                        </h4>
                        <div className="mt-2 flex items-center gap-3">
                          <span className="text-xs text-foreground-600">{article.date}</span>
                          <span className="text-xs text-foreground-600 flex items-center gap-1">
                            <i className="ri-eye-line w-3 h-3 flex items-center justify-center"></i>
                            {formatViews(article.views)}
                          </span>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="px-4 md:px-8 py-12 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              <div className="relative rounded-2xl overflow-hidden aspect-[16/10]">
                <img
                  src={data.articles[1]?.image || data.articles[0]?.image || ""}
                  alt="更多爆料"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-100/90 to-transparent"></div>
                <div className="absolute top-4 left-4">
                  <span className="px-2.5 py-1 rounded-full bg-background-100/60 backdrop-blur-sm text-foreground-400 text-xs whitespace-nowrap">
                    更多大瓜
                  </span>
                </div>
                <div className="absolute bottom-6 left-6 right-6">
                  <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-50 leading-tight">
                    更多爆料
                  </h2>
                </div>
              </div>

              <div className="flex flex-col justify-center items-center text-center px-4">
                <h2 className="text-2xl md:text-3xl font-heading text-foreground-50 mb-4">
                  相关爆料
                </h2>
                <p className="text-sm text-foreground-500 leading-relaxed max-w-md mb-8">
                  浏览更多{data.title}相关的最新爆料内容，不错过每一个精彩大瓜。每日实时更新，一手信息尽在掌握。
                </p>
                <Link
                  to="/"
                  className="px-6 py-2.5 bg-foreground-50 hover:bg-foreground-200 text-background-900 text-sm font-medium rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center gap-2"
                >
                  返回首页
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}